import { Box } from "@mui/material"
import { LightErrorAlertBox } from "../../../../components/AlertBoxes.styled"

const BioAlert = () => {
  return (
    <LightErrorAlertBox sx={{ marginTop: '4px', flexDirection: 'column', alignItems: "center" }}>
      <Box>Attention: You have unassigned spore test boxes in your account.</Box>
      <Box>Please assign your boxes to an autoclave.</Box>
    </LightErrorAlertBox>
  )
}

export default BioAlert
